import { getAuthAxiosBackend } from "../helpers/axios"

class PassportServices{

    get(id){
        return getAuthAxiosBackend().get('Passports/getPassports/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('Passports/getPassportsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('Passports/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('Passports/addPassports', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('Passports/updatePassports/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('Passports/softDeletePassports/' + id.toString())
    }
}

export default new PassportServices()